module.exports = __webpack_public_path__ + "img/df59776.jpg";